import { useState } from 'react'
import { LivenessStep } from './steps/liveness-step'

export enum KYCStep {
  LIVENESS = 'liveness',
  COMPLETION = 'completion',
}

export function KYCFlow() {
  const [step, setStep] = useState<KYCStep>(KYCStep.LIVENESS)

  return (
    <div className="flex h-full w-full items-center justify-center">
      {step === KYCStep.LIVENESS && (
        <LivenessStep onComplete={() => setStep(KYCStep.COMPLETION)} />
      )}
    </div>
  )
}
